import { Spinner } from "@hightouch/htui";

import { PreworkspacePage } from "src/components/layout/preworkspace-page";
import { AuthenticatedRoute } from "src/components/router/authenticated-route";
import { NoContextOutlet } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

const AsanaInstallPage = lazyNamed(() => import("./asana-install"), "Page");

const AsanaInstallLayout = () => {
  return (
    <PreworkspacePage title="Connect to Asana">
      <NoContextOutlet />
    </PreworkspacePage>
  );
};

export const routes = {
  path: "asana-install",
  element: <AsanaInstallLayout />,
  children: [
    {
      index: true,
      element: (
        <AuthenticatedRoute loadingFallback={<Spinner size="lg" m="auto" />}>
          <AsanaInstallPage />
        </AuthenticatedRoute>
      ),
    },
  ],
};
